/* eslint-disable prettier/prettier */
/* eslint-disable max-len */
import { NavLink } from 'react-router';

import { UikitMenuSidebar } from '../../components/UikitMenuSidebar';
import { UikitMenu } from '../../components/UikitMenu';
import { routes } from '../../routes';

const BASE_URL = `/${routes.COMPONENTS}`;
const title = 'Components';

const navLinkClass = ({ isActive }: { isActive: boolean }) => (isActive ? 'active' : undefined);

export const NewBadge = () => (
    <span className='padding-bottom-5'>
        <span className='badge badge-success text-uppercase text-size-10 margin-left-10'>new</span>
    </span>
);

export const getComponentsMenuItems = () => {
    const menu = [
        {
            group: 'Application',
            navItems: [
                {
                    key: 'ApplicationLayout',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/appLayout`}>
                            ApplicationLayout
                        </NavLink>
                    ),
                    meta: 'appLayout applicationLayout',
                },
                {
                    key: 'ApplicationHeader',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/appHeader`}>
                            ApplicationHeader
                        </NavLink>
                    ),
                    meta: 'appHeader actionBarItems serviceInfo about title applicationHeader',
                },
                {
                    key: 'BottomSheet',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/bottomSheet`}>
                            BottomSheet
                        </NavLink>
                    ),
                    meta: 'bottomSheet timed',
                },
                {
                    key: 'Sidebar',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/sidebar`}>
                            Sidebar
                        </NavLink>
                    ),
                    meta: 'sidebar',
                },
            ],
        },
        {
            group: 'Navigation',
            navItems: [
                {
                    key: 'MainNavigation',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/mainNavigation`}>
                            MainNavigation
                        </NavLink>
                    ),
                    meta: 'main navigation',
                },
                {
                    key: 'SubNavigation',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/subNavigation`}>
                            SubNavigation
                        </NavLink>
                    ),
                    meta: 'subNavigation navigation',
                },
                {
                    key: 'AppNavigationBar',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/appNavigationBar`}>
                            AppNavigationBar
                        </NavLink>
                    ),
                    meta: 'appNavigationBar navigation',
                },
                {
                    key: 'PagerPage',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/pager`}>
                            Pager
                        </NavLink>
                    ),
                    meta: 'pager button',
                },
                {
                    key: 'Pills',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/pills`}>
                            Pills
                            <NewBadge />
                        </NavLink>
                    ),
                    meta: 'pills nav-pills navigation view switcher',
                },
            ],
        },
        {
            group: 'Interaction',
            navItems: [
                {
                    key: 'Button',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/button`}>
                            Button
                        </NavLink>
                    ),
                    meta: 'button',
                },
                {
                    key: 'ButtonToolbar',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/buttonToolbar`}>
                            ButtonToolbar
                        </NavLink>
                    ),
                    meta: 'buttonToolbar',
                },
                {
                    key: 'ButtonGroup',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/buttonGroup`}>
                            ButtonGroup
                            <NewBadge />
                        </NavLink>
                    ),
                    meta: 'buttonGroup',
                },
                {
                    key: 'Checkbox',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/checkbox`}>
                            Checkbox
                        </NavLink>
                    ),
                    meta: 'checkbox',
                },
                {
                    key: 'ClearableInput',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/clearableInput`}>
                            ClearableInput
                        </NavLink>
                    ),
                    meta: 'clearableInput inputmask mask inputpattern pattern',
                },
                {
                    key: 'CountedInput',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/countedInput`}>
                            CountedInput
                        </NavLink>
                    ),
                    meta: 'countedInput char counter validation input addon clearable min max',
                },
                {
                    key: 'EditableContent',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/editableContent`}>
                            EditableContent
                        </NavLink>
                    ),
                    meta: 'editableContent text inline edit',
                },
                {
                    key: 'LoadMoreButton',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/loadMore`}>
                            LoadMoreButton
                        </NavLink>
                    ),
                    meta: 'loadMore',
                },
                {
                    key: 'NumberControl',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/numbercontrol`}>
                            NumberControl
                        </NavLink>
                    ),
                    meta: 'numbercontrol',
                },
                {
                    key: 'RadioButton',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/radiobutton`}>
                            RadioButton
                        </NavLink>
                    ),
                    meta: 'radiobutton radio',
                },
                {
                    key: 'RadioCardGroup',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/radioCardGroup`}>
                            RadioCardGroup
                        </NavLink>
                    ),
                    meta: 'radioCardGroup radioCardItem cards options radio',
                },
                {
                    key: 'StepButton',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/stepButton`}>
                            StepButton
                        </NavLink>
                    ),
                    meta: 'stepbutton next previous more',
                },
                {
                    key: 'SaveableInput',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/saveableInput`}>
                            SaveableInput
                        </NavLink>
                    ),
                    meta: 'save input edit form saveableInput',
                },
                {
                    key: 'Slider',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/sliders`}>
                            Slider
                        </NavLink>
                    ),
                    meta: 'sliders range',
                },
                {
                    key: 'Switch',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/switch`}>
                            Switch
                        </NavLink>
                    ),
                    meta: 'switch',
                },
                {
                    key: 'ToggleButton',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/toggleButton`}>
                            ToggleButton
                        </NavLink>
                    ),
                    meta: 'toggleButton',
                },
                {
                    key: 'AnalyticsAnalysisOverlay',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/analyticsAnalysisOverlay`}>
                            AnalyticsAnalysisOverlay
                        </NavLink>
                    ),
                    meta: 'analytics overlay ga tracking',
                },
            ],
        },
        {
            group: 'Show/Hide',
            navItems: [
                {
                    key: 'Collapse',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/collapse`}>
                            Collapse
                        </NavLink>
                    ),
                    meta: 'collapse',
                },
                {
                    key: 'Expanders',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/expander`}>
                            Expanders
                        </NavLink>
                    ),
                    meta: 'expander',
                },
                {
                    key: 'Fade',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/fade`}>
                            Fade
                        </NavLink>
                    ),
                    meta: 'fade transition animate',
                },
                {
                    key: 'FadeExpander',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/fadeExpander`}>
                            FadeExpander
                        </NavLink>
                    ),
                    meta: 'fadeExpander transition animate expand collapse',
                },
                {
                    key: 'FadeUp',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/fadeUp`}>
                            FadeUp
                        </NavLink>
                    ),
                    meta: 'fadeUp transition animate',
                },
            ],
        },
        {
            group: 'Selection',
            navItems: [
                {
                    key: 'AssetTree',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/assetTree`}>
                            <span>AssetTree</span>
                        </NavLink>
                    ),
                    meta: 'assetTree tree',
                },
                {
                    key: 'AutoSuggest',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/autosuggests`}>
                            AutoSuggest
                        </NavLink>
                    ),
                    meta: 'autosuggests',
                },
                {
                    key: 'Dropdowns',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/dropdowns`}>
                            ButtonDropdown
                        </NavLink>
                    ),
                    meta: 'button dropdowns SimpleButtonDropdown splitbutton',
                },
                {
                    key: 'Selects',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/selects`}>
                            Select
                        </NavLink>
                    ),
                    meta: 'selects multiselect dropdown',
                },
                {
                    key: 'Multiselects',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/multiselects`}>
                            Multiselect
                        </NavLink>
                    ),
                    meta: 'selects multiselect dropdown',
                },
            ],
        },
        {
            group: 'Pickers',
            navItems: [
                {
                    key: 'DayPicker',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/dayPicker`}>
                            DayPicker
                        </NavLink>
                    ),
                    meta: 'dayPicker react-day-picker input dropdown date range multiple',
                },
                {
                    key: 'DayPickerCalendar',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/dayPickerCalendar`}>
                            DayPickerCalendar
                        </NavLink>
                    ),
                    meta: 'dayPickerCalendar react-day-picker calendar standalone embedded dialog modifiers',
                },
                {
                    key: 'DatePickers',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/datepickers`}>
                            DatePicker
                        </NavLink>
                    ),
                    meta: 'datepickers picker',
                },
                {
                    key: 'FilePickers',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/filePickers`}>
                            FilePicker
                        </NavLink>
                    ),
                    meta: 'filePickers picker',
                },
                {
                    key: 'TimePickers',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/timepicker`}>
                            TimePicker
                        </NavLink>
                    ),
                    meta: 'timepicker picker',
                },
            ],
        },
        {
            group: 'Progress',
            navItems: [
                {
                    key: 'BarList',
                    item: <NavLink to={`${BASE_URL}/barList`}>BarList</NavLink>,
                    meta: 'BarList progress',
                },
                {
                    key: 'CircularProgress',
                    item: <NavLink to={`${BASE_URL}/circularProgress`}>CircularProgress</NavLink>,
                    meta: 'CircularProgress',
                },
                {
                    key: 'StatusBar',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/statusBar`}>
                            StatusBar
                        </NavLink>
                    ),
                    meta: 'statusBar',
                },
                {
                    key: 'SteppedProgress',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/steppedProgressBars`}>
                            SteppedProgress
                        </NavLink>
                    ),
                    meta: 'steppedProgressBars',
                },
                {
                    key: 'Tracker',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/tracker`}>
                            Tracker
                        </NavLink>
                    ),
                    meta: 'tracker',
                },
            ],
        },
        {
            group: 'Content',
            navItems: [
                {
                    key: 'Animations',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/animations`}>
                            Animations
                        </NavLink>
                    ),
                    meta: 'animations',
                },
                {
                    key: 'AnimatedNumber',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/animatedNumber`}>
                            AnimatedNumber
                        </NavLink>
                    ),
                    meta: 'animatedNumber',
                },
                {
                    key: 'AnimatedTextReveal',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/animatedTextReveal`}>
                            AnimatedTextReveal
                        </NavLink>
                    ),
                    meta: 'animatedTextReveal textShimmer gradient',
                },
                {
                    key: 'Banner',
                    item: <NavLink to={`${BASE_URL}/banner`}>Banner</NavLink>,
                    meta: 'Banner announcements info',
                },
                {
                    key: 'Card',
                    item: <NavLink to={`${BASE_URL}/card`}>Card</NavLink>,
                    meta: 'Card panel box',
                },
                {
                    key: 'Carousel',
                    item: <NavLink to={`${BASE_URL}/carousel`}>Carousel</NavLink>,
                    meta: 'carousel',
                },
                {
                    key: 'ContentLoader',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/contentLoader`}>
                            ContentLoader
                        </NavLink>
                    ),
                    meta: 'contentLoader',
                },
                {
                    key: 'DataTabs',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/dataTabs`}>
                            DataTabs
                        </NavLink>
                    ),
                    meta: 'dataTabs',
                },
                {
                    key: 'TabbedPanel',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/tabbedPanel`}>
                            TabbedPanel
                        </NavLink>
                    ),
                    meta: 'tabbedPanel tabs panel nav pills animated body',
                },
                {
                    key: 'Dialogs',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/dialogs`}>
                            Dialogs
                        </NavLink>
                    ),
                    meta: 'dialogs split save confirmation info simple media release releasenotes frame onboarding',
                },
                {
                    key: 'FormLabel',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/formLabel`}>
                            FormLabel
                        </NavLink>
                    ),
                    meta: 'form label formlabel',
                },
                {
                    key: 'GroupedItemList',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/groupedItemList`}>
                            GroupedItemList
                        </NavLink>
                    ),
                    meta: 'groupedItemList lists items',
                },
                {
                    key: 'LabeledElement',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/labeledElement`}>
                            LabeledElement
                        </NavLink>
                    ),
                    meta: 'LabeledElement label form',
                },
                {
                    key: 'NoData',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/noData`}>
                            NoData
                        </NavLink>
                    ),
                    meta: 'noData',
                },
                {
                    key: 'Page',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/page`}>
                            Page
                        </NavLink>
                    ),
                    meta: 'page document paper',
                },
                {
                    key: 'ResponsiveColumnStripe',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/responsiveColumnStripe`}>
                            ResponsiveColumnStripe
                        </NavLink>
                    ),
                    meta: 'responsiveColumnStripe',
                },
                {
                    key: 'States',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/states`}>
                            States
                        </NavLink>
                    ),
                    meta: 'states ErrorState EmptyState NotFoundState ForbiddenState MaintenanceState CustomState NotBookedState tableState',
                },
                {
                    key: 'StatsWidgets',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/statsWidgets`}>
                            StatsWidgets
                        </NavLink>
                    ),
                    meta: 'statsWidgets',
                },
                {
                    key: 'Teaser',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/teaser`}>
                            Teaser
                        </NavLink>
                    ),
                    meta: 'teaser',
                },
                {
                    key: 'TextTruncateMiddle',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/textTruncateMiddle`}>
                            TextTruncateMiddle
                        </NavLink>
                    ),
                    meta: 'TextTruncateMiddle text truncate middle ellipsis',
                },
                {
                    key: 'VirtualList',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/virtualList`}>
                            VirtualList
                        </NavLink>
                    ),
                    meta: 'virtuallist infinite scrolling',
                },
            ],
        },
        {
            group: 'Table',
            navItems: [
                {
                    key: 'Table',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/table`}>
                            Table component
                        </NavLink>
                    ),
                    meta: 'table gridtable datatable table hover table bordered table striped table grouped table sticky table gridlines table double row header table condensed table fixed table responsive table states table styles rowanimation',
                },
                {
                    key: 'TableControls',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/tableControls`}>
                            Table controls
                        </NavLink>
                    ),
                    meta: 'table controls tabletoolbar tablesearch view toggles cards sorting',
                },
                {
                    key: 'HtmlTable',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/htmlTable`}>
                            HTML table
                        </NavLink>
                    ),
                    meta: 'html native table thead tbody tablehead tablecol tablesettingsdialog table hover table bordered table striped table grouped table sticky table gridlines table rowspan table double row header table condensed table fixed table responsive table-responsive table states table styles',
                },
            ],
        },
        {
            group: 'Misc',
            navItems: [
                {
                    key: 'AccentBar',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/accentBar`}>
                            AccentBar
                        </NavLink>
                    ),
                    meta: 'AccentBar indicator',
                },
                {
                    key: 'Activity',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/activity`}>
                            Activity
                        </NavLink>
                    ),
                    meta: 'activity',
                },
                {
                    key: 'AspectRatioPlaceholder',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/aspectRatioPlaceholder`}>
                            AspectRatioPlaceholder
                        </NavLink>
                    ),
                    meta: 'aspect placeholder image',
                },
                {
                    key: 'Avatar',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/avatar`}>
                            Avatar
                        </NavLink>
                    ),
                    meta: 'avatar initials abbr username',
                },
                {
                    key: 'CalendarStripe',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/calendarStripe`}>
                            CalendarStripe
                        </NavLink>
                    ),
                    meta: 'calendarStripe',
                },
                {
                    key: 'Divider',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/divider`}>
                            Divider
                        </NavLink>
                    ),
                    meta: 'divider',
                },
                {
                    key: 'Feedback',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/feedback`}>
                            Feedback
                        </NavLink>
                    ),
                    meta: 'feedback rating thumbs-up thumbs-up smiley',
                },
                {
                    key: 'Image',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/image`}>
                            Image
                            <NewBadge />
                        </NavLink>
                    ),
                    meta: 'image responsive',
                },
                {
                    key: 'ParallaxImage',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/parallaxImage`}>
                            ParallaxImage
                            <NewBadge />
                        </NavLink>
                    ),
                    meta: 'image responsive parallax hero',
                },
                {
                    key: 'ImagePreloader',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/imagePreloader`}>
                            ImagePreloader
                        </NavLink>
                    ),
                    meta: 'image preloader',
                },
                {
                    key: 'ListMenu',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/listMenu`}>
                            ListMenu
                        </NavLink>
                    ),
                    meta: 'listMenu',
                },
                {
                    key: 'LicensePlate',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/licensePlate`}>
                            LicensePlate
                        </NavLink>
                    ),
                    meta: 'licenseplate',
                },
                {
                    key: 'Notifications',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/notifications`}>
                            Notifications
                        </NavLink>
                    ),
                    meta: 'notifications',
                },
                {
                    key: 'Onboarding',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/onboarding`}>
                            Onboarding
                        </NavLink>
                    ),
                    meta: 'onboarding useOnboarding onboardingtip onboardingtour tour',
                },
                {
                    key: 'Popover',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/popover`}>
                            Popover
                        </NavLink>
                    ),
                    meta: 'popover',
                },
                {
                    key: 'Position',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/position`}>
                            Position
                        </NavLink>
                    ),
                    meta: 'position',
                },
                {
                    key: 'ReleaseNotes',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/releaseNotes`}>
                            ReleaseNotes
                        </NavLink>
                    ),
                    meta: 'releaseNotes',
                },
                {
                    key: 'Resizer',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/resizer`}>
                            Resizer
                        </NavLink>
                    ),
                    meta: 'resizer',
                },
                {
                    key: 'Responsive Video',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/responsiveVideo`}>
                            ResponsiveVideo
                        </NavLink>
                    ),
                    meta: 'responsiveVideo',
                },
                {
                    key: 'Icon',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/icon`}>
                            Icon
                        </NavLink>
                    ),
                    meta: 'icon uikit-icon paired fuelicon',
                },
                {
                    key: 'Rules',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/rules`}>
                            Rules
                        </NavLink>
                    ),
                    meta: 'rules connector container rulecontainer ruleconnector',
                },
                {
                    key: 'SmoothScrollbars',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/smoothScrollbars`}>
                            SmoothScrollbars
                        </NavLink>
                    ),
                    meta: 'smoothscrollbar',
                },
                {
                    key: 'Spinner',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/spinners`}>
                            Spinner
                        </NavLink>
                    ),
                    meta: 'spinners loader',
                },
                {
                    key: 'supportMarker',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/supportMarker`}>
                            SupportMarker
                        </NavLink>
                    ),
                    meta: 'supportMarker',
                },
                {
                    key: 'Illustration',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/Illustration`}>
                            Illustration
                        </NavLink>
                    ),
                    meta: 'svgimage svgicon illustration',
                },
                {
                    key: 'TagManager',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/tagManager`}>
                            TagManager
                        </NavLink>
                    ),
                    meta: 'tagManager',
                },
                {
                    key: 'Tags',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/tags`}>
                            Tags
                        </NavLink>
                    ),
                    meta: 'tags',
                },
                {
                    key: 'Tooltip',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/tooltip`}>
                            Tooltip
                        </NavLink>
                    ),
                    meta: 'tooltip simple',
                },
            ],
        },
        {
            group: 'CSS Only',
            navItems: [
                {
                    key: 'Chat',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/chat`}>
                            Chat
                        </NavLink>
                    ),
                    meta: 'chat css only',
                },
                {
                    key: 'IconList',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/iconList`}>
                            IconList
                        </NavLink>
                    ),
                    meta: 'iconList css only',
                },
                {
                    key: 'Timeline',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/timeline`}>
                            Timeline
                        </NavLink>
                    ),
                    meta: 'timeline css only',
                },
            ],
        },
        {
            group: 'Map',
            navItems: [
                {
                    key: 'mapSetup',
                    meta: 'map setup getting started',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/mapGettingStarted`}>
                            Map - Getting started
                        </NavLink>
                    ),
                },
                {
                    key: 'Map',
                    meta: 'map',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/basicMap`}>
                            Map
                        </NavLink>
                    ),
                },
                {
                    key: 'Cluster',
                    meta: 'map cluster',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/mapCluster`}>
                            Map cluster
                        </NavLink>
                    ),
                },
                {
                    key: 'Marker',
                    meta: 'map marker  mapmarker SingleMapMarker ClusterMapMarker',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/mapMarker`}>
                            Map marker
                        </NavLink>
                    ),
                },
                {
                    key: 'DraggableMarker',
                    meta: 'map draggable marker',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/mapDraggableMarker`}>
                            Map draggable marker
                        </NavLink>
                    ),
                },
                {
                    key: 'Map settings',
                    meta: 'map settings',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/mapSettings`}>
                            Map settings
                        </NavLink>
                    ),
                },
                {
                    key: 'MapViewportHistory',
                    meta: 'map viewport history previous position',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/mapViewportHistory`}>
                            Map viewport history
                        </NavLink>
                    ),
                },
                {
                    key: 'Layer',
                    meta: 'map layer',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/mapLayerGroup`}>
                            Map layer group
                        </NavLink>
                    ),
                },
                {
                    key: 'InfoBubble',
                    meta: 'map infoBubble',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/mapInfoBubble`}>
                            Map InfoBubble
                        </NavLink>
                    ),
                },
                {
                    key: 'Circle',
                    meta: 'map circle',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/mapCircle`}>
                            Map circle
                        </NavLink>
                    ),
                },
                {
                    key: 'Polygon',
                    meta: 'map polygon isoline',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/mapPolygon`}>
                            Map polygon & isoline
                        </NavLink>
                    ),
                },
                {
                    key: 'Route',
                    meta: 'map route',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/mapRoute`}>
                            Map route
                        </NavLink>
                    ),
                },
                {
                    key: 'ContextMenu',
                    meta: 'map context',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/mapContext`}>
                            Map context menu
                        </NavLink>
                    ),
                },
                {
                    key: 'MapUtils',
                    meta: 'map utils',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/mapUtils`}>
                            Map utils
                        </NavLink>
                    ),
                },
                {
                    key: 'MapRouteGenerator',
                    meta: 'map route generator',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/mapRouteGenerator`}>
                            Route generator demo
                        </NavLink>
                    ),
                },
                {
                    key: 'MapFullscreenDemo',
                    meta: 'map fullscreen',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/fullscreenMap`}>
                            Map fullscreen demo
                        </NavLink>
                    ),
                },
            ],
        },

        {
            group: 'Charts',
            navItems: [
                {
                    key: 'gettingStarted',
                    meta: 'charts getting started',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/chartsGettingStarted`}>
                            Charts - Getting Started
                        </NavLink>
                    ),
                },
                {
                    key: 'ChartColors',
                    meta: 'chartColors',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/chartColors`}>
                            Chart Colors
                        </NavLink>
                    ),
                },
                {
                    key: 'AreaCharts',
                    meta: 'areacharts',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/areaCharts`}>
                            AreaCharts
                        </NavLink>
                    ),
                },
                {
                    key: 'ComposedCharts',
                    meta: 'composedcharts',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/composedCharts`}>
                            ComposedCharts
                        </NavLink>
                    ),
                },
                {
                    key: 'LineCharts',
                    meta: 'linecharts',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/lineCharts`}>
                            LineCharts
                        </NavLink>
                    ),
                },
                {
                    key: 'BarCharts',
                    meta: 'barcharts',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/barCharts`}>
                            BarCharts
                        </NavLink>
                    ),
                },
                {
                    key: 'PieCharts',
                    meta: 'piecharts',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/pieCharts`}>
                            PieCharts
                        </NavLink>
                    ),
                },
                {
                    key: 'RadialBarCharts',
                    meta: 'radialbarcharts',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/radialBarCharts`}>
                            RadialBarCharts
                        </NavLink>
                    ),
                },
            ],
        },
    ];

    return menu.map(item => ({ ...item, badge: title }));
};

export const ComponentsMenu = () => (
    <UikitMenuSidebar title={title}>
        <UikitMenu />
    </UikitMenuSidebar>
);
